export const NOT_SET = '(not set)';
export const segmentGaSessionID =
  process.env.NEXT_PUBLIC_BUILD_ENV === 'production'
    ? '_ga_99QLETVG9M'
    : '_ga_BY9M0PX696';
export const segmentTrackEventLocations = {
  eventCreation: 'Event Creation',
  eventManagement: 'Event Management',
};
